/* Core & libraries */
import React from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";


/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import {ReactComponent as EditSvg} from 'resources/images/edit.svg';

/* Styles */
import styles from "./styles";

const EditUCInputModal = ({showModal, setShowModal, handleSubmit, fieldName, value, fieldLabel, fullName}) => {
  const theme = useTheme();
  const classes = styles({theme});

  return (
    <UCModal
      keepOnBackdrop
      className={classes.editUCInputModal}
      showModal={showModal}
      setShowModal={setShowModal}
      modalIcon={<EditSvg className={classes.iconColor}/>}
      modalTitle={<FormattedMessage id="edit.UC.input.modal.title" values={{fieldLabel}}/>}
      modalDescription={<>
        <FormattedMessage id="edit.UC.input.modal.description" values={{fieldLabel, value: fullName}}/>
        <br/>
        <br/>
        <FormattedMessage id="edit.UC.input.modal.description.info"/>
      </>}
      modalContent={<Content setShowModal={setShowModal} handleSubmit={handleSubmit} fieldLabel={fieldLabel}
                             fieldName={fieldName} value={value}/>}
      dataTestId="editUcInputModal"
    />
  )
}

export default EditUCInputModal;
